// extracted by mini-css-extract-plugin
module.exports = {"Polynomials":"Polynomials_Polynomials__1uv8V","Polynomial":"Polynomials_Polynomial__2tL5S"};